export enum ConnectionType {
  LockPondsStatusChange = 'LockPondsStatusChange',
  SiteChange = 'SiteChange',
}
